var _path;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgDigitalBusinessCard(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 54,
    height: 54,
    viewBox: "0 0 54 54",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M9 9C6.51375 9 4.5 11.0138 4.5 13.5V40.5C4.5 42.9863 6.51375 45 9 45H45C47.4863 45 49.5 42.9863 49.5 40.5V13.5C49.5 11.0138 47.4863 9 45 9H9ZM9 13.5H45V40.5H9V13.5ZM13.5 18V24.75H20.25V18H13.5ZM33.7324 20.25C30.0424 20.25 26.7142 21.7136 24.2842 24.1436L27.4351 27.3384C29.0776 25.7409 31.2799 24.75 33.7324 24.75C36.1849 24.75 38.3917 25.7409 40.0342 27.3384L43.1851 24.1436C40.7551 21.7136 37.4224 20.25 33.7324 20.25ZM33.7324 29.25C32.4949 29.25 31.3959 29.7452 30.5859 30.5552L33.7324 33.75L36.8833 30.5552C36.0733 29.7452 34.9699 29.25 33.7324 29.25Z",
    fill: "black"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgDigitalBusinessCard);
export default __webpack_public_path__ + "static/media/Digital-business-card.89683994c1c4b7faeed162fbaa412b38.svg";
export { ForwardRef as ReactComponent };